import instObj from '@/backend/axios-instances'

const resource = "customer/portal"
const instance = instObj.customerInstance

export default {
  get(apiToken) {
    return instance.get(`${resource}/${apiToken}`);
  }
}
